import { yupResolver } from '@hookform/resolvers/yup';
import { CustomButton, CustomInputCheckBox, CustomInputSelect, CustomTextInput } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { IAcquirerTransactionsByNetworkCardTypeMeta } from '@Modules/reporting/containers/forms/transactions/statistics/acquirerTransactionsByNetworkCardType/AcquirerTransactionsByNetworkCardTypeMeta';
import { useForm } from 'react-hook-form';
import { FaPrint } from 'react-icons/fa';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import CustomReactSelect from '@Modules/core/components/form/CustomReactSelect';

type Props = {
  onSubmit: any,
  meta: IAcquirerTransactionsByNetworkCardTypeMeta,
  isLoading?: boolean,
  isSubmitting: boolean,
};

export const AcquirerTransactionsByNetworkCardTypeFormUI = ({ meta, onSubmit, isSubmitting }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema),});

  return (
    <>
      <CC.Heading as='h1' size={'md'}   fontWeight="normal" mb="1%">
      Transactions acquéreur par type carte reseau
      </CC.Heading>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CC.SimpleGrid columns={{ base: 1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={4}>
            {displayCustomInputs<IAcquirerTransactionsByNetworkCardTypeMeta>(
              meta,
              register,
              errors,
              false,
            )}
        </CC.SimpleGrid>
        <CC.Flex justify={'end'} mt={'1em'}>
          <CustomButton isLoading={isSubmitting} type='submit'><FaPrint style={{marginRight: '10px'}} /> Imprimer</CustomButton>
        </CC.Flex>
      </form>
    </>
  )
}